<template>
  <div>
    <b-row>
      <b-col cols="12" class="text-center">
        <b-row>
          <b-col cols="12" md="2" class="text-start title-spacing">
            <strong>Location</strong>
          </b-col>
          <b-col cols="12" md="4" class="text-start title-spacing">
            <strong>POS GL Code</strong>
          </b-col>
          <b-col cols="12" md="4" class="text-start title-spacing">
            <strong>Web Order GL Code</strong>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-for="(item, index) in items" :key="index">
      <b-col cols="12" md="2" class="text-start">
        {{ item.locationName }}
      </b-col>
      <b-col cols="12" md="4">
        <p-advanced-select
          data-type="chartOfAccounts"
          v-model="item.posChartOfAccountsId"
          :filter="filterChartOfAccounts"
          style="display: block; width: 100%; max-height: 34px; padding-right: 10px; margin-bottom: 15px;"
          @change="$emit('change')"
        />
      </b-col>
      <b-col cols="12" md="4">
        <p-advanced-select
          data-type="chartOfAccounts"
          v-model="item.webChartOfAccountsId"
          :filter="filterChartOfAccounts"
          style="display: block; width: 100%; max-height: 34px; padding-right: 10px; margin-bottom: 15px;"
          @change="$emit('change')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    emits: ['change'],
    props: {
      items: {
        type: Array,
        required: true
      },
      fields: {
        type: Array,
        required: true
      }
    },
    methods: {
      filterChartOfAccounts(chartOfAccount) {
        return chartOfAccount.type == 'Sales Tax' || chartOfAccount.type == null;
      }
    }
  };
</script>

<style scoped>
.text-center {
  text-align: center;
}
.text-start {
  text-align: left;
}
.title-spacing {
  margin-bottom: 7px;
}
</style>